function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "delete");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "4_Mediacenter",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "1.1_Mediacenter_Individueller-Filter",
  transform: "translate(-1287.000000, -640.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Produktname_001",
  transform: "translate(330.000000, 105.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2",
  transform: "translate(16.000000, 426.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Auswahl-Copy-4",
  transform: "translate(743.000000, 24.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "filter-copy-3",
  transform: "translate(199.000000, 86.000000)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  stroke: "#909090",
  strokeWidth: 0.3,
  cx: 7,
  cy: 7,
  r: 7
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.8,6.8 L6.8,3.4 C6.8,3.28954305 6.88954305,3.2 7,3.2 C7.11045695,3.2 7.2,3.28954305 7.2,3.4 L7.2,6.8 L10.6,6.8 C10.7104569,6.8 10.8,6.88954305 10.8,7 C10.8,7.11045695 10.7104569,7.2 10.6,7.2 L7.2,7.2 L7.2,10.6 C7.2,10.7104569 7.11045695,10.8 7,10.8 C6.88954305,10.8 6.8,10.7104569 6.8,10.6 L6.8,7.2 L3.4,7.2 C3.28954305,7.2 3.2,7.11045695 3.2,7 C3.2,6.88954305 3.28954305,6.8 3.4,6.8 L6.8,6.8 Z",
  id: "Combined-Shape",
  fill: "#909090",
  transform: "translate(7.000000, 7.000000) rotate(45.000000) translate(-7.000000, -7.000000) "
})))))));

var SvgDelete = function SvgDelete(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDelete, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/delete.b393c9aa.svg";
export { ForwardRef as ReactComponent };